import { InjectionToken } from '@angular/core';

import { LoggerConfig } from '../logger-config';

export const METADATA_TOKEN = new InjectionToken<MetadataService>('logger.metadata');

export interface MetadataService {
  getMetadata: (level: number, config: LoggerConfig, message?: any, additional?: any[]) => LoggerMetadata;
}

export interface LoggerMetadata {
  additional?: any[];
  columnNumber?: number;
  fileName?: string;
  level: number;
  lineNumber?: number;
  message?: any;
  timestamp?: string;
}
